<div class="kr-wallet-item">
  <img
    class="kr-wallet-item__img"
    src="assets/images/wallet-card.png"
    [alt]="wallet().name" />

  <div class="kr-wallet-item__content">
    <div class="kr-wallet-item__content-title">{{ wallet().name }}</div>
    <div class="kr-wallet-item__content-sub-title">
      <img
        width="12"
        height="12"
        [src]="wallet().coin?.image?.url"
        alt="coin" />
      <span>{{
        wallet().balanceAvailable | balanceFormat: wallet().coin.symbol
      }}</span>
    </div>
  </div>
</div>
